export enum MerchantFileType {
  COMPANY_DOCUMENT = 'COMPANY_DOCUMENT',
}
